<div class="accordion" *ngIf="showGraphSection && (mostRecentExecuted.execution.executionStatus !== 'IN_PROGRESS' && mostRecentExecuted.execution.executionStatus !== 'PENDING')">
  <h6 class="clickable mt-2 mb-2" (click)="showGraph = !showGraph">
    <span>
      <i class="fas fa-caret-right clickable collapse-icon p-1" *ngIf="!showGraph"></i>
      <i class="fas fa-caret-down clickable collapse-icon p-1" *ngIf="showGraph"></i>Performance Graph</span>
  </h6>
  <div *ngIf="showGraph">
    <app-mobile-performance-graph class="mt-2 mb-2" [mostRecentExecuted]="mostRecentExecuted" [parentIndex]="parentIndex" [type]="'ENDPOINT'"></app-mobile-performance-graph>
  </div>
</div>
<div class="table-responsive" *ngIf="mostRecentExecuted.mobileEndPoint || mostRecentExecuted.desktopEndPoint">
  <table class="result-table" style="table-layout:fixed">
    <thead>
      <tr>
        <th width="16%">Name</th>
        <th width="10%">Locator</th>
        <th width="12%">Action</th>
        <th width="10%">Input</th>
        <th width="7%"  class="text-center">Wait Time</th>
        <th width="32%" class="text-center">Start Time & End Time</th>
        <th width="6%" class="text-center">Time Taken</th>
        <th width="7%">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let mobileInstruction of mobileInstructions | orderBy: 'asc':'instructionSequence'; index as i">
        <td class="overflow-table-display">
          <div ngbTooltip="{{mobileInstruction.name}}" container="body" placement="right">
            {{mobileInstruction.instructionSequence}}. {{ mobileInstruction.name }}
          </div>
        </td>
        <td>
          <ng-template #htmlContent>
            Component Type : {{mobileInstruction.mobileLocator.mobileComponentType}} <br>
            Locator Type : {{mobileInstruction.mobileLocator.mobileLocatorType}} <br>
            Locator Value : {{mobileInstruction.mobileLocator.mobileLocatorValue}} <br>
            Locator Defined Value : {{mobileInstruction.mobileLocator.mobileLocatorValueDefined}} <br>
          </ng-template>
          <div [ngbTooltip]="htmlContent" container="body" placement="right" class="overflow-table-display">{{mobileInstruction.mobileLocator.name}}</div>
        </td>
        <td class="overflow-table-display">{{ mobileInstruction.mobileAction }}</td>
        <td>
          <div class="overflow-table-display" (click)="openComponentInputDialog(mobileInstruction)">{{
            mobileInstruction.mobileComponentInput }}</div>
        </td>
        <td class="text-center">{{ mobileInstruction.waitTime}}</td>
        <td class="text-center"> {{ mobileInstruction.startTime | localDate }} - {{ mobileInstruction.endTime | localDate }}</td>
        <td class="text-center">{{ mobileInstruction.totalExecutionTimeInSec | secondsToHms }}</td>
        <td class="d-flex align-items-center">
          <div class="status-badge status-{{ mobileInstruction.executionStatus.toLowerCase() }}" ngbTooltip="{{mobileInstruction.executionStatus}}" container="body">
            <i class="fas" [ngClass]="{
              'fa-clock': mobileInstruction.executionStatus === 'PENDING',
              'fa-check-circle': mobileInstruction.executionStatus === 'PASSED',
              'fa-redo': mobileInstruction.executionStatus === 'SKIPPED',
              'fa-exclamation-triangle': mobileInstruction.executionStatus === 'VALID_FAIL',
              'fa-times-circle': mobileInstruction.executionStatus === 'FAILED',
              'fa-hand-paper': mobileInstruction.executionStatus === 'ABORTED',
              'fa-sync-alt fa-spin': mobileInstruction.executionStatus === 'IN_PROGRESS',
              'fa-step-forward': mobileInstruction.executionStatus === 'JUMP'
            }"></i>
          </div>
          <i class="fas fa-info-circle ml-2" (click)="openInfoDialog(mobileInstruction)" ngbTooltip="Info" placement="left"></i>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<hr>